import { render, staticRenderFns } from "./app-document.scene.vue?vue&type=template&id=26afe269&scoped=true"
import script from "./app-document.scene.ts?vue&type=script&lang=ts&external"
export * from "./app-document.scene.ts?vue&type=script&lang=ts&external"
import style0 from "./app-document.scene.scss?vue&type=style&index=0&id=26afe269&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26afe269",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
